import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { STEPS, CONTACT_MEDIA, NEW_CONTACT_MEDIA } from '@/constants/account';
import { actions } from '@/reducers/account-reducer';
import getDeviceKindDependsOnViewPort from '@gcloud-npm/utils.common.get-device-kind-depends-on-viewport';
import { useForm } from 'react-hook-form';

function useAccountForm({ initStep = STEPS.NEW_ACCOUNT }) {
  const dispatch = useDispatch();
  const step = useSelector((state) => state.account.step);
  const loading = useSelector((state) => state.account.loadingForm);
  const { formError, requiredOTPs } = useSelector((state) => state.sms);
  const [requiredOTP] = Array.isArray(requiredOTPs) ? requiredOTPs : [];
  const { phoneNumber: contactMedia } = { ...requiredOTP };
  const { handleSubmit, control, setError, resetField } = useForm({
    mode: 'onSubmit',
    reValidateMode: 'onBlur',
  });
  const onSubmit = async (formData) => {
    if (step === STEPS.CONTACT_MEDIA || step === STEPS.NEW_CONTACT_MEDIA) {
      const deviceKind = getDeviceKindDependsOnViewPort();
      dispatch(
        actions.setInfo({
          formData,
          deviceKind,
          step,
        })
      );
    }
    if (step === STEPS.NEW_ACCOUNT || step === STEPS.RECOVERY_ACCOUNT) {
      dispatch(
        actions.setStep({
          step: STEPS.CONTACT_MEDIA,
        })
      );
    }
  };
  useEffect(() => {
    if (!step) {
      dispatch(
        actions.setStep({
          step: initStep,
        })
      );
    }
  }, []);
  useEffect(() => {
    if (!step) {
      dispatch(
        actions.setStep({
          step: initStep,
        })
      );
    }
  }, []);

  useEffect(() => {
    if (formError) {
      if (step === STEPS.CONTACT_MEDIA) {
        setError(CONTACT_MEDIA.ID, {
          type: 'server',
          message: formError,
        });
      } else if (step === STEPS.NEW_CONTACT_MEDIA) {
        setError(NEW_CONTACT_MEDIA.ID, {
          type: 'server',
          message: formError,
        });
      }
    }
  }, [formError]);

  return {
    handleSubmit: handleSubmit(onSubmit),
    control,
    step,
    loading,
    contactMedia,
    formError,
    resetField,
  };
}

export default useAccountForm;
